import { HeaderSkeleton } from './HeaderSkeleton';

export default HeaderSkeleton;
